/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { FixedPriceQuoteTemplateDetailsResource } from './';
import {
    FixedPriceQuoteTemplateDetailsResourceFromJSON,
    FixedPriceQuoteTemplateDetailsResourceFromJSONTyped,
    FixedPriceQuoteTemplateDetailsResourceToJSON,
} from './';
import type { QuoteStatus } from './';
import {
    QuoteStatusFromJSON,
    QuoteStatusFromJSONTyped,
    QuoteStatusToJSON,
} from './';
import type { QuoteTemplateResource } from './';
import {
    QuoteTemplateResourceFromJSON,
    QuoteTemplateResourceFromJSONTyped,
    QuoteTemplateResourceToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceQuoteTemplateResource
 */
export interface FixedPriceQuoteTemplateResource extends QuoteTemplateResource {
    /**
     * 
     * @type {FixedPriceQuoteTemplateDetailsResource}
     * @memberof FixedPriceQuoteTemplateResource
     */
    details: FixedPriceQuoteTemplateDetailsResource;
}

/**
 * Check if a given object implements the FixedPriceQuoteTemplateResource interface.
 */
export function instanceOfFixedPriceQuoteTemplateResource(value: object): value is FixedPriceQuoteTemplateResource {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function FixedPriceQuoteTemplateResourceFromJSON(json: any): FixedPriceQuoteTemplateResource {
    return FixedPriceQuoteTemplateResourceFromJSONTyped(json, false);
}

export function FixedPriceQuoteTemplateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceQuoteTemplateResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteTemplateResourceFromJSONTyped(json, ignoreDiscriminator),
        'details': FixedPriceQuoteTemplateDetailsResourceFromJSON(json['details']),
    };
}

export function FixedPriceQuoteTemplateResourceToJSON(value?: FixedPriceQuoteTemplateResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteTemplateResourceToJSON(value, true),
        'details': FixedPriceQuoteTemplateDetailsResourceToJSON(value['details']),
    };
}

